import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import AdminLayout from "../components/admin/AdminLayout";
import AdminBlog from "../components/admin/AdminBlog";
import AdminProjects from "../components/admin/AdminProjects";
import AdminServices from "../components/admin/AdminServices";
import AdminLeads from "../components/admin/AdminLeads";

export default function AdminDashboard() {
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();
  const [tab, setTab] = useState("blog");

  useEffect(() => {
    if (!loading && !user) navigate("/admin/login");
  }, [loading, user, navigate]);

  if (loading || !user) {
    return <div className="min-h-screen grid place-items-center text-muted-foreground">Loading…</div>;
  }

  return (
    <AdminLayout
      tab={tab}
      onTab={setTab}
      onLogout={() => {
        logout();
        navigate("/admin/login");
      }}
    >
      {tab === "blog" && <AdminBlog />}
      {tab === "projects" && <AdminProjects />}
      {tab === "services" && <AdminServices />}
      {tab === "leads" && <AdminLeads />}
    </AdminLayout>
  );
}
